import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/Auth';

const AuthTokenReducer = handleActions({
    [Actions.LoginRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.LoginReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        isAuthorized: !!action.payload.token,
        data: action.payload,
        errors: {},
    }),
    [Actions.LoginReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        isAuthorized: false,
    }),
    [Actions.LogoutRequestedReceived]: (state) => ({
        ...state,
        isAuthorized: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    isAuthorized: false,
    data: {},
    errors: {},
});

const UIState = handleActions({
    [Actions.LoginReceived]: (state) => ({
        ...state,
        isAuthExpired: false,
    }),
    [Actions.AuthExpireConfirmed]: (state) => ({
        ...state,
        isAuthExpired: false,
    }),
    [Actions.LoginReceiveFailure]: (state) => ({
        ...state,
        isAuthExpired: true,
    }),
}, {
    isAuthExpired: false,
});

const SetShowDialogAuthReducer = handleActions({
    [Actions.SetShowDialogAuth]: (state, action) => ({
        isOpen: action.payload,
    }),
}, {
    isOpen: false,
});

export default combineReducers({
    credential: AuthTokenReducer,
    uistate: UIState,
    isOpenDialogNotAuth: SetShowDialogAuthReducer,
});
